<script lang="ts">
	import { onMount, type Snippet } from "svelte"
	import ImageModifySidebar from "./sidebar/SnapshotModifySidebar.svelte"
	import { SidebarController } from "./sidebar/SidebarController.svelte"

	interface Props {
		canvas: Snippet
	}

	let { canvas }: Props = $props()

	let isMounted = $state(false)

	onMount(() => {
		SidebarController.setView("default")
		isMounted = true
	})
</script>

<div class="image-modify">
	{#if isMounted}
		<ImageModifySidebar />
		{@render canvas()}
	{/if}
</div>

<style>
	.image-modify {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: row;
		overflow: hidden;
	}

	:global(.isMobile) .image-modify {
		flex-direction: column;
	}
</style>
